<template>
    <modal v-model="isActive" v-model:loading="isChangingLocale" small :title="t('action.switch_language')">
        <form-select :model-value="locale" @select="handleSelectedLocaleOption" :options="langOptions" large only-options/>
    </modal>
</template>

<script setup lang="ts">
import {ToggleableComponentEmits, type ToggleableComponentProps} from "../../types";
import {useToggleableComponent} from "../../composables/useToggleableComponent";
import {useI18n, useNuxtApp} from "#imports";
import {ref} from "vue";

const props = defineProps<{

} & ToggleableComponentProps>();

const emit = defineEmits(ToggleableComponentEmits);
const {isActive} = useToggleableComponent(props, emit);

const {t, locales, locale, setLocale} = useI18n();
const {$auth, $apiFetch} = useNuxtApp();

const langOptions = locales.value.map(localeValue => {
	return {value: localeValue.code, iso: localeValue.iso, text: localeValue.name + (localeValue.beta ? ' (Beta)' : ''), image: localeValue.flag, subtitle: localeValue.code.toUpperCase()}
})

const isChangingLocale = ref(false);

/**
 * We handle the locale change via an emit listener to only trigger this logic when the user explicitly changes the locale via this component
 */
function handleSelectedLocaleOption(localeOption) {
	isChangingLocale.value = true;

	// If a user is authenticated, we persist the change on the database to have it synced on all devices and for notifications in the preferred language
	if ($auth.loggedIn) {
		$apiFetch('/v1/athletes/my/locale', {
			method: 'PUT',
			params: {
				locale: localeOption.iso
			}
		}).then(() => {
			$auth.user.locale = localeOption.iso;
			setClientLocale(localeOption.value);
		}).catch(error => {
			console.error(error);
			isChangingLocale.value = false;
		})
	} else {
		setClientLocale(localeOption.value);
	}
}

async function setClientLocale(localeCode) {
	await setLocale(localeCode)
	isChangingLocale.value = false;
	isActive.value = false;
}
</script>